import React, { useEffect, useState } from 'react';
import { Image } from 'react-native';
import { ActivityIndicator, FlatList, ScrollView, View } from "react-native"
import { useDispatch, useSelector } from "react-redux"
import BuyNowOrderCard from '../../Componentsv1/BuyNowOrderCard';
import Colors from "../../constants/Colorsv2"
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { event_getAllPrices, event_getEventByEventId, event_getMatchByMatchId, event_getTournamentByTournamentId, event_updateMatch, event_updateTournament } from '../../store/actionsv1/events';
import { market_getOrderBook, market_getTradesByEventIdAndMarketId, market_setDraftOrder, market_updateMarketResolve } from '../../store/actionsv1/markets';
import { MarketProps, OrderProps, TradeProps } from '../../store/types/mk_svc';
import AthleteMarketCard from './components/AthleteMarketCard';
import BidAskProgressChart from './components/BidAskProgressChart';
import EventInfoCard from './components/EventInfoCard';
import MatchMarketCard from './components/MatchMarketCard';
import OrderBookCard from './components/OrderBookCard';
import EventMarketCard from './components/EventMarketCard';
import { market_filterTrades, market_getMarketsFromSupportedMarkets } from './helpers/markets';
import { order_getCheapestOrders, order_getOrdersFromUniqueVar1 } from './helpers/orders';
import TournamentInfoCard from './components/TournamentInfoCard';
import MatchInfoCard from './components/MatchInfoCard';
import { AthleteProps, EventProps, ExternalPriceProps, MatchProps, TournamentProps } from '../../store/types/sr_svc';
import TeamMarketCard from './components/TeamMarketCard';
import ExternalPriceCard from './components/ExternalPriceModal';
import { Icon } from 'react-native-elements';
import { trade_reverseTradeSide } from './helpers/trades';
import moment from 'moment';
import { PlayerPremiumItem, PublicPlayerProps } from '../../store/types/auth_svc';
import { event_getSideLabelsFromActiveMarket } from './helpers/events';
import { social_getRelatedGroupId } from '../../store/actionsv1/social';
import GroupChatModal from '../Social/components/GroupChatModal';
import ExoticMarketCard from './components/ExoticMarketCard';
import PriceHistoryChart from './GolfWidget/PriceHistoryChart';
import { V1_LOAD_EXTERNAL_PRICE_COMPARISON } from '../../store/actionsv1/types';
import ALaCartePremium from '../../globalComponents/ALaCartePremium';
import { Helmet } from 'react-helmet-async';



type MarketscreenStateProps = {
    external_price_visible: boolean,
    actions_visible:boolean,
    active_market:MarketProps | undefined,
    active_var_1: number,
    order_book_loading:boolean,
    bid_ask_loading:boolean,
    market_data_loading:boolean,
    trade_data_loading:boolean,
    order_book_offset: number,
    last_market_id:string | undefined
}
const MarketScreen = ({ navigation, route}:any) => {

    //SET UP THE COMPONENTS STATE PROPS
    const [ market_state, setMarketState ] = useState<MarketscreenStateProps>({
        external_price_visible: false,
        market_data_loading:false,
        order_book_loading:false,
        trade_data_loading:false,
        actions_visible: false,
        active_market:undefined,
        bid_ask_loading: false,
        active_var_1: 0,
        order_book_offset: 0,
        last_market_id: undefined
    })
    const [ action_location, setActionLocation ] = useState({ x:0, y:0, height:0, width:0 });
    const [ chat_visible, setChatVisible ] = useState(false);
    const [ group_id, setGroupId ] = useState<string | undefined>(undefined)
    const [ toggleBoxWidth, setToggleBoxWidth ] = useState(300);
    const { external_price_visible, bid_ask_loading, order_book_loading, order_book_offset, market_data_loading, trade_data_loading, actions_visible, active_market, active_var_1 } = market_state;
    
    let participant_id = route.params.participant_id && route.params.participant_id != 'undefined' ? route.params.participant_id : undefined

    //Dispatch for interacting with the REDUX store
    const dispatch = useDispatch()

    //REDUX STORE SELECTORS
    let premium = false
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const init_loaded:boolean = useSelector((state:any) => state.util.init_loaded, (left, right) => left == right);
    const player_premium_item = useSelector((state:any) => state.player.player_premium_items_list.player_premium_items.find(ppi => ppi.premium_item?.identifier == 'advanced_market_analytics'), (left, right) => left?.last_update_datetime == right?.last_update_datetime);
    if(player?.type == 'premium'|| player_premium_item){ premium = true }
    const market_type:string = useSelector((state:any) => state.auth.market_type, (left, right) => left === right)
    let trades = useSelector((state:any) => market_filterTrades(state.market.trades.filter((t:TradeProps) => t.market_type === state.auth.market_type), route.params.event_id, route.params.event_type, participant_id).filter((t:TradeProps) => t.var_1 == active_var_1), (left, right) => left.length === right.length)
    trades = trades.sort((a,b) => moment(b.create_datetime).unix() - moment(a.create_datetime).unix())
    const latest_trades_list: TradeProps[] | undefined = useSelector((state:any) => state.market.latest_trades[`${route.params.event_type}:${route.params.event_id}`], (left, right) => left == right);
    let latest_trades:TradeProps[] = []
    if(latest_trades_list){ latest_trades = latest_trades_list.filter(t => t.market_type == market_type) }
    const latest_trade = trades[0]
    const latest_o_trade = trade_reverseTradeSide(latest_trade, active_market)
    let trades_override:TradeProps[] = []
    if(latest_trade && latest_o_trade){
        trades_override = [latest_o_trade, latest_trade]
    }
    const leagues = useSelector((state:any) => state.event.leagues, (left, right) => left.length === right.length)
    const event:EventProps|undefined = useSelector((state:any) => state.event.events[route.params.event_id], (left, right) => {
        if(left?.event_id != right?.event_id){ return false }
        if(left?.time_detail != right?.time_detail){ return false }
        return true
    })
    const athlete:AthleteProps|undefined = useSelector((state:any) => state.event.athletes_list.athletes.find(a => a.athlete_id == participant_id), (left, right) => left?.athlete_id == right?.athlete_id)

    const app_size: { width:number, height:number } = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
    const tournament = useSelector((state:any) => state.event.tournaments[route.params.event_id], (left, right) => left?.tournament_id == right?.tournament_id)
    const match:MatchProps|undefined = useSelector((state:any) => state.event.matches[route.params.event_id], (left, right) => {
        if(left?.time_detail != right?.time_detail){ return false }
        if(left?.match_id != right?.match_id){ return false }
        return true
    })
    const order_book = useSelector((state:any) => state.market.order_book, (left, right) => {
        if(left?.updated != right?.updated){ return false }
        return true
    })


    let orders = useSelector((state:any) => state.market.orders.filter((o:OrderProps) => o.market_type === state.auth.market_type && o.event_id == route.params.event_id && o.event_type === route.params.event_type && o.market_id == active_market?.market_id), (left:OrderProps[], right:OrderProps[]) => {
        if(left.length !== right.length){  return false }
        if(left[0]?.order_id != right[0]?.order_id){ return false }
        const left_sum = left.reduce((a,b) => a + b.open_amt, 0)
        const right_sum = right.reduce((a,b) => a + b.open_amt, 0)
        if(left_sum !== right_sum){ return false }
        const left_prob_length = left.filter(l => l.jump_queue_probability || l.buy_now_probability).length
        const right_prob_length = right.filter(l => l.jump_queue_probability || l.buy_now_probability).length
        if(left_prob_length !== right_prob_length){ return false }
        return true
    })
    if(active_var_1){
        orders = orders.filter(o => Math.abs(o.var_1) == Math.abs(active_var_1))
    }
    
    if(participant_id && route.params.event_type !== 'match'){ orders = orders.filter(o => o.side_id == participant_id) }
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left.length === right.length)
    
    //Set up the markets that are available in the toggle only if there is an active market currently
    let supported_markets:any[] = route.params.event_type === 'team' ? event?.supported_markets??[] : route.params.event_type === 'match' ? match?.supported_markets : tournament?.supported_markets??[]
    let available_markets:MarketProps[] = market_getMarketsFromSupportedMarkets(supported_markets, markets)
    if(active_market){
        //If there is an active market - lets figure out what are the related markets to it
        available_markets = available_markets.filter(m => m.level == active_market.level && m.primary_market == active_market.primary_market)
    }

    //If the active market level is not event, we need to shorted to the participant id markets
    if(active_market && active_market.level != 'event'){
        if(athlete){
            available_markets = available_markets.filter(m => m.supported_positions && athlete && m.supported_positions.includes(athlete.position))
        }
        if(active_market.level == 'exotic'){
            available_markets = [active_market]
        }
    }


    const prices:ExternalPriceProps[] = useSelector((state:any) => state.event.prices.filter(p => p.event_id == route.params.event_id && p.event_type == route.params.event_type && p.market_id == active_market?.market_id && p.side == active_market?.trade_side && p.var_1 == active_var_1), (left, right) => {
        if(left.length != right.length){ return false }
        if(left[0]?.event_id != right[0]?.event_id){ return false }
        return true
    });
    let filtered_prices = prices;
    if(participant_id){
        filtered_prices = prices.filter(p => p.participant_id == participant_id && p.participant_type == active_market?.side_options[0].id_source)
    }
    

    let actions:{ label:string, action:string, icon:string, locked?:boolean }[] = [
        { action: 'my_activity', label: 'My Order Activity', icon:'activity' },
        { action: 'additional_markets', label: 'Additional Markets', icon: 'trending-up' },
        { action: 'chat', label: 'Smack Talk', icon: 'message-circle' },
        { action: 'external_prices', label: 'External Prices', icon: 'eye', locked: player?.type == 'fremium' ? true: false }
    ]
    if(player?.role == 'admin'){
        actions.push({ action: 'resolve_market', label: 'Resolve Market', icon: 'check-circle' })
        if(route.params.event_type == 'match'){
            actions.push({ action: 'close_event', label: 'Close Match', icon: 'x-circle' })
        }
    }

    //Initial Load of the page - we will need to set the activeMarket
    //Then we will get the market data from the server
    useEffect(() => {
        console.log(init_loaded)
        if(markets.length === 0 || !init_loaded){ return }//Don't do anything if there are no markets
        getGroupIdFromServer()
        setMarketState({
            ...market_state,
            active_market: markets.find(m => m.market_id == route.params.market_id)
        })
    },[route.params.event_id, markets.length, init_loaded])

    useEffect(() => {
        if(!active_market){ return }
        getMarketDataFromServer(route.params.event_id)
    },[route.params.event_id, active_market])


    const getGroupIdFromServer = async() => {
        let group_id = await social_getRelatedGroupId(route.params.event_id, route.params.event_type)
        if(!group_id){ return }
        setGroupId(group_id)
    }

    /**
     * Grab event info if needed then also get the latest trade
     * @param event_id 
     * @param market_id 
     */
    const getMarketDataFromServer = async(event_id:string) => {
        setMarketState({ ...market_state, market_data_loading:true, order_book_loading: true, bid_ask_loading:true, })
        if(route.params.event_type === 'team' && !event){ dispatch(await event_getEventByEventId(event_id)) }
        if(route.params.event_type === 'tournament' && !tournament){ dispatch(await event_getTournamentByTournamentId(event_id)) }
        if(route.params.event_type === 'match' && !match){ dispatch(await event_getMatchByMatchId(event_id)) }
        //await dispatch(market_getLatestTradesByEventId(event_id, route.params.event_type))
        if(active_market){ 
            console.log(latest_trades.length)
            await dispatch(event_getAllPrices(event_id, route.params.event_type, 0, active_market.market_id, participant_id))
            await getTradeHistoryFromServer(route.params.event_id, route.params.event_type, active_market.market_id, latest_trade?.var_1??0)
            let default_trade:TradeProps|undefined
            if(participant_id){ 
                default_trade = latest_trades.find(t => t.market_id == active_market.market_id && t.side == active_market.trade_side && t.side_id == participant_id)
            } else {
                default_trade = latest_trades.find(t => t.market_id == active_market.market_id && t.side == active_market.trade_side)
            }
            if(default_trade){
                console.log('getting order book!!!')
                await getOrderBookFromServer(route.params.event_id, route.params.event_type, default_trade.market_id, default_trade?.var_1??0)
            } else {
                await getOrderBookFromServer(route.params.event_id, route.params.event_type, active_market.market_id, 0)
            }
            setMarketState({
                ...market_state,
                market_data_loading: false,
                order_book_loading: false,
                bid_ask_loading: false,
                active_var_1: active_market.var_1_required ? default_trade?.var_1??0 : 0,
                order_book_offset: 0
            })
        }
        //setMarketState({ ...market_state, market_data_loading:false })
    }
    const getOrderBookFromServer = async(event_id:string, event_type:string, market_id:string, var_1:number, offset?:number) => {
        if(!market_id){ return }
        console.log(event_id, market_id, var_1)
        await dispatch(market_getOrderBook(event_id, event_type, market_id, var_1, offset??0, participant_id))
    }
        
    const getTradeHistoryFromServer = async(event_id:string, event_type:string, market_id:string, var_1:number) => {
        await dispatch(market_getTradesByEventIdAndMarketId(event_id, event_type, market_id, 0, var_1, participant_id))
    }

    const handleChangeVar1 = async(var_1:number) => {
        if(!active_market){ return }
        setMarketState({
            ...market_state,
            order_book_loading:true
        })
        await getOrderBookFromServer(route.params.event_id, route.params.event_type, active_market.market_id, var_1)
        setMarketState({
            ...market_state,
            active_var_1: var_1,
            order_book_offset: 0,
            order_book_loading: false
        })
    }

    const renderMarkets = (data: { item:MarketProps, index:number }) => {
        const active = active_market?.market_id == data.item.market_id ? true : false
        return (
            <TouchableOpacity style={{ minWidth:toggleBoxWidth/available_markets.length, padding:12, justifyContent:'center', alignItems:'center',
                borderRadius:5, backgroundColor:active?Colors.shades.white : 'transparent', shadowColor: active ?"rgba(0, 0, 0, 0.2)": 'transparent', 
                shadowOffset: { width: 0, height: 1 }, shadowRadius: 0, shadowOpacity: 1 }}
                onPress={() => !market_data_loading ? setMarketState({
                    ...market_state,
                    active_market: data.item
                }) : console.log('loading')}
            >
                <Text size={14} color={Colors.brand.midnight} weight='regular' textAlign='center'>{data.item.stat_label ?? data.item.type}</Text>
            </TouchableOpacity>
        )
    }

    const handleAction = (action:string) => {
        setMarketState({
            ...market_state,
            actions_visible: false
        })
        switch(action){
            case 'resolve_market':
                if(!active_market){ return }
                dispatch(market_updateMarketResolve({
                    event_id: route.params.event_id,
                    event_type: route.params.event_type,
                    market_id: active_market.market_id,
                    side_id: participant_id,
                    side_type: participant_id ? active_market.side_options[0].id_source : undefined,
                    updated: 1
                }))
                return
            case 'close_event':
                if(route.params.event_type == 'tournament' && tournament){
                    return dispatch(event_updateTournament({ ...tournament, status: 'closed' }))
                }
                if(route.params.event_type == 'match' && match){
                    return dispatch(event_updateMatch({ ...match, status:'closed' }))
                }
            case 'my_activity': return navigation.push('EventOrders', { event_id:route.params.event_id, event_type: route.params.event_type })
            case 'external_prices': 
                return dispatch({ 
                    type:V1_LOAD_EXTERNAL_PRICE_COMPARISON, 
                    external_price_comparison : {
                        event_id: route.params.event_id,
                        event_type: route.params.event_type,
                        participant_id: participant_id,
                        init_market: active_market,
                        live: live,
                        available_markets: available_markets
                    }
                })
            case 'chat':
                return setChatVisible(true);
            case 'additional_markets':
                if(route.params.event_type === 'team'){
                    return navigation.push('AdditionalMarkets', { event_id: route.params.event_id })
                }
                if(route.params.event_type === 'match'){
                    if(!match){ return }
                    return navigation.push('Tournament', { tournament_id: match.tournament_id })
                }
                return navigation.push('Tournament', { tournament_id: route.params.event_id })
            default: return
        }
    }
 
    const handleOrderBookSelect = (order:OrderProps) => {
        if(order.player_id == player?.player_id){
            return alert('This is your order')
        }
        return dispatch(market_setDraftOrder({ ...order, open_amt: Math.floor(order.open_amt * 100) / 100, order_type: 'limit', buy_sell_ind: 'buy', selling_position_id: undefined }))
    }

    const renderActions = (data: {item:{ action:string, label:string, icon:string, locked?:boolean }, index:number}) => {
        return (
            <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', marginBottom:10 }} onPress={() => handleAction(data.item.action)}>
                <View style={{ padding:10, paddingLeft:20, borderRightWidth:1, borderColor:Colors.shades.shade600 }}>
                    <Icon name={data.item.locked?'lock':data.item.icon} type='feather' size={18} color={data.item.locked?Colors.incentive.gold:Colors.brand.electric} />
                </View>
                <Text weight='semibold' style={{ padding:10 }} size={14} color={data.item.locked?Colors.incentive.gold:Colors.brand.electric}>{data.item.label}</Text>
            </TouchableOpacity>
        )
    }

    if(!active_market){
        return (
            <View style={{ flex:1, justifyContent:'center', alignItems:'center', padding:50, backgroundColor:Colors.shades.white }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight} />
            </View>
        )
    }
    const filtered_orders = order_getOrdersFromUniqueVar1(orders, active_var_1, active_market)
    const { trade_side_cheapest, other_side_cheapest } = order_getCheapestOrders(filtered_orders, active_market)
    const { away_label, home_label } = event_getSideLabelsFromActiveMarket(active_market, event)
    let live = false 
    if(event){ live = moment().isAfter(moment(event?.scheduled_datetime)) ? true : false }
    let trade_amt = 0
    if(trades.length > 0){ trade_amt = trades[0].cumulative_amt }

    const open_amt = filtered_orders.reduce((a,b) => a + b.open_amt , 0);

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            {event ?
            <Helmet>
                <title>{event.event_title} Betting Markets</title>
                <meta property='og:description' content={`Bet on ${event.event_title} against others and not the house.`}/>
            </Helmet>
            :<></>}
            <ScrollView style={{ flex:1, paddingBottom:65 }}>
                <View nativeID='info-header' style={{ padding:20  }}>
                    {route.params.event_type === 'team' && event ?
                    <View>

                        <EventInfoCard event={event} league={leagues.find(l => l.league_id == event.league_id)}/>
                    </View>
                    :<></>}
                    {route.params.event_type === 'tournament' && tournament ?
                    <TournamentInfoCard tournament={tournament} league={leagues.find(l => l.league_id == tournament.league_id)}/>
                    :<></>}
                    {route.params.event_type === 'match' && match ?
                    <MatchInfoCard match={match} league={leagues.find(l => l.league_id === match?.tournament?.league_id)} tournament={match?.tournament}/>
                    :<></>}
                </View>
                <View style={{padding:10, backgroundColor:Colors.shades.white}}>
                    {!order_book || bid_ask_loading ?
                    <View style={{ padding:20 }}>
                        <ActivityIndicator size='small' color={Colors.brand.midnight}/>
                    </View>
                    :
                    <View>
                        <BidAskProgressChart 
                            order_book={order_book}
                            awayLabel={away_label??''}
                            homeLabel={home_label??''}
                            market={active_market}
                            side_id_override={participant_id}
                            onVar1Select={(var_1:number) => handleChangeVar1(var_1)}
                            activeVar1={active_var_1}
                        />
                    </View>
                    }
                    <Image style={{alignSelf:'center', height:1, width:355}} source={require('../../assets/images/faded_line.png')} />
                </View>
                <View style={{ backgroundColor:Colors.shades.white, margin:5, marginRight:20, marginLeft:20 }}>
                    <View nativeID='market-toggle' style={{ flex:1, padding:2, flexDirection:'row', borderRadius: 6, backgroundColor: Colors.shades.shade100 }} onLayout={(ev) => {
                        const { width } = ev.nativeEvent.layout;
                        setToggleBoxWidth(width)
                    }}>
                        <FlatList data={available_markets} renderItem={renderMarkets} keyExtractor={(item) => item.market_id.toString()} horizontal showsHorizontalScrollIndicator={false}/>
                    </View>
                </View>
                {market_data_loading ?
                 <View style={{ justifyContent:'center', alignItems:'center', padding:50 }}>
                    <ActivityIndicator size='large' color={Colors.brand.midnight} />
                </View>
                :
                <>
                <View nativeID='market-order' style={{ padding:10 }}>
                    <View nativeID='ob' style={{ padding:10 }}>
                        <Text size={14} color={Colors.shades.black} weight='bold' textAlign='center'>MARKET ORDER - {active_market.stat_label ?? active_market.type.toUpperCase()}</Text>
                    </View>
                    <View style={{ padding:10 }}>
                        {active_market.level === 'event' && active_market.event_type === 'team' ?
                        <EventMarketCard source='market' prevent_event_load trades_override={trades_override} navigation={navigation} event_id={route.params.event_id} hide_event_header hide_market_headers hide_market_footers market_override={active_market}/>
                        : active_market.level === 'event' && active_market.event_type === 'match' ?
                        <MatchMarketCard trades_override={trades_override} navigation={navigation} match_id={route.params.event_id} market_override={active_market} hide_market_footers />
                        : active_market.level === 'athlete' ?
                        <AthleteMarketCard hide_event_info trades_override={trades_override} navigation={navigation} event_id={route.params.event_id} event_type={route.params.event_type} athlete_id={participant_id} market_override={active_market} hide_market_footers/>
                        : active_market.level === 'team' ?
                        <TeamMarketCard navigation={navigation} market_override={active_market} event_id={route.params.event_id} event_type={route.params.event_type} team_id={participant_id} hide_market_footers/>
                        : active_market.level === 'exotic' ?
                        <ExoticMarketCard navigation={navigation} market_override={active_market} event_id={route.params.event_id} event_type={route.params.event_type} exotic_id={participant_id} hide_event_info hide_market_footers />
                        :
                        <></>}
                    </View>
                </View>
                {other_side_cheapest || trade_side_cheapest ?
                <View nativeID='best-available' style={{ padding:10 }}>
                    <View nativeID='ob' style={{ padding:10 }}>
                        <Text size={14} color={Colors.shades.black} weight='bold' textAlign='center'>BEST AVAILABLE ORDERS</Text>
                    </View>
                    <View style={{ flex:1, flexDirection:'row', padding:10}}>
                        {other_side_cheapest ?
                        <View style={{ flex:1 }}>
                            <BuyNowOrderCard order={other_side_cheapest} onBuy={(order) => dispatch(market_setDraftOrder(order))}/>
                        </View>
                        :
                        <View style={{ flex:1 }} />
                        }
                        <View style={{ flex:1/10 }} />
                        {trade_side_cheapest ?
                        <View style={{ flex:1 }}>
                            <BuyNowOrderCard order={trade_side_cheapest} onBuy={(order) => dispatch(market_setDraftOrder(order))}/>
                        </View>
                        :
                        <View style={{ flex:1 }} />
                        }
                    </View>        
                </View>
                :<></>}
                <ALaCartePremium identifier='advanced_market_analytics'/>
                {orders.length > 0 ?
                <View nativeID='order-book' style={{ backgroundColor:Colors.shades.shade100, padding:10 }}>
                    <View nativeID='ob' style={{ padding:10 }}>
                        <Text size={14} color={Colors.shades.black} weight='bold' textAlign='center'>ORDER BOOK</Text>
                        <Text style={{ marginTop:3 }} size={14} color={Colors.shades.black} weight='regular' textAlign='center'>${open_amt.toFixed(2)} Available</Text>
                    </View>
                    <View style={{ padding:10 }}>
                        {!order_book_loading ?
                        <OrderBookCard orders={orders} market={active_market} onBuy={(order) => handleOrderBookSelect(order)}/>
                        :
                        <></>
                        }
                        {false ?
                        <TouchableOpacity style={{ marginTop:5, borderRadius:4, borderColor:Colors.brand.midnight, borderWidth:1, padding:10 }} onPress={() => { 
                                    getOrderBookFromServer(route.params.event_id, route.params.event_type, active_market.market_id, active_var_1, order_book_offset + 1)
                                    return setMarketState({
                                        ...market_state,
                                        order_book_offset: order_book_offset + 1
                                    })
                                }}>
                            <Text textAlign='center' size={14} color={Colors.brand.midnight} weight='semibold'>LOAD MORE</Text>
                        </TouchableOpacity>
                        :<></>}
                    </View>                 
                </View>
                :<></>}
                <View nativeID='price_history' style={{ padding:10}}>
                    <View nativeID='ph_header' style={{ padding:10 }}>
                        <Text size={14} color={Colors.shades.black} weight='bold' textAlign='center'>PRICE HISTORY</Text>
                        {latest_trade ?
                        <Text style={{ marginTop:3 }} size={14} color={Colors.shades.black} weight='regular' textAlign='center'>${latest_trade.cumulative_amt.toFixed(2)} Traded</Text>
                        :<></>}
                    </View>
                    <View style={{ margin:10, ...local_styles.raised }}>
                        {true && prices.length > 0 ?
                        <View style={{ marginTop:10, paddingLeft:-15 }}>
                            <PriceHistoryChart
                                external_prices={filtered_prices}
                                trades={trades}
                                level={premium ? 'premium' : 'freemium'}
                                width={app_size.width - 40}
                            />
                        </View>
                        :<></>}
                    </View>
                </View>
                 {trades_override.length === 0 && orders.length === 0 ?
                <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                    <Text size={14} color={Colors.brand.electric} weight='semibold' textAlign='center'>It looks like you are the first here! Open this market by creating a limit order or challenge a friend!</Text>
                </View>
                :<></>}
                </>}
            </ScrollView>
            <GroupChatModal 
                group_id={group_id} 
                top={action_location.y - 40} 
                show_last_message
                onLastMessageUpdate={() => 'hey'}
                onCloseExpand={() => setChatVisible(false)}
                left={action_location.x}
                expanded_width={app_size.width}
                expanded={chat_visible}
                />
            <View style={{ position:'absolute', bottom:10, left:10, alignItems:'flex-start' }} onLayout={(ev) => {
                const { width, height, x, y } = ev.nativeEvent.layout
                setActionLocation({ x, y, height, width })
            }}>
                {actions_visible ?
                <View style={{ padding:10, borderRadius:8, borderBottomLeftRadius:0, backgroundColor:Colors.shades.white, shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }}>
                    <FlatList data={actions} renderItem={renderActions} keyExtractor={(item) => item.action}/>
                </View>
                :<></>}
                <TouchableOpacity style={{ justifyContent:'center', alignContent:'center', borderRadius:100, borderTopLeftRadius:actions_visible?0:100, borderTopRightRadius:actions_visible?0:100, height:50, width:50, backgroundColor: actions_visible?Colors.shades.white:Colors.brand.electric,  shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }} onPress={() => setMarketState({
                    ...market_state,
                    actions_visible: !actions_visible
                })}>
                    {actions_visible ?
                    <Icon name='x' type='feather' size={20} color={Colors.utility.error} />
                    :
                    <Icon name='more-vertical' type='feather' size={20} color={Colors.shades.white} />
                    }
                </TouchableOpacity>
            </View>
        </View>
    )
}


const local_styles = {
    raised: { shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }
}

export default MarketScreen